var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginTestimateIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M20.5 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h17Z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#D3F4FF",
  points: "20.5 5 3.5 5 3.5 19 20.5 19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M18.503 14.503h-5.21v-1.128l2.4-2.523c.592-.673.887-1.208.887-1.605 0-.32-.07-.565-.21-.733-.14-.167-.344-.251-.61-.251a.76.76 0 0 0-.641.336c-.164.224-.246.503-.246.838H13.14a2.452 2.452 0 0 1 1.297-2.179 2.833 2.833 0 0 1 1.364-.328c.807 0 1.428.186 1.864.559.435.372.653.907.653 1.605 0 .294-.054.58-.164.858-.11.279-.28.571-.51.877-.23.306-.602.715-1.115 1.228l-.964 1.113h2.938v1.333ZM6.42 8.03c.426 0 .785.102 1.078.305.293.203.537.533.732.99l.569 1.283 1.207-2.484h1.717l-2.11 4.3 1.108 2.479c.175.395.404.621.685.68l.188.023.193-.006-.146 1.342c-.114.027-.24.045-.381.053-.344.02-.624-.02-.841-.12-.217-.1-.426-.277-.627-.53-.201-.254-.427-.686-.677-1.295l-.375-.85L7.416 16.9H5.74l2.197-4.523L6.93 10.08c-.18-.45-.518-.674-1.014-.674l-.38.035L5.5 8.165c.309-.09.615-.135.92-.135Z"
}))));
export default SvgPluginTestimateIcon;